<template>
<div id="secure">
    <section class="main-content columns is-fullheight vld-parent">
        <SideMenu />

        <div class="container column is-9">
            <loading :active.sync="isLoading" 
                :can-cancel="false" 
                :is-full-page="fullPage">
            </loading>

            <div class="section">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>

                <!-- <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Download QR Tags for teachers</p>
                    </div>
                    <div class="card-content">
                        <div class="content"><button class='button is-primary' v-on:click="downloadQRTags()">
                            Download QR Tags
                        </button></div>
                    </div>
                </div>
                <br /> -->

                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Import Teachers from excel (xlsx)</p>
                    </div>
                    <div class="card-content">
                        <div class="content">                            
                            <b-field class="file">                      
                                <b-upload v-model="file">
                                    <a class="button is-primary">
                                        <i class='upload icon'></i>
                                        <span>Import teachers from excel</span>
                                    </a>
                                </b-upload>
                                <span class="file-name" v-if="file">{{ file.name }}</span>
                                <b-select placeholder="Overwrite option" id="option1"  v-model="input.option1">
                                    <option value="1">Add only new teachers</option>
                                    <option value="2">Remove all teachers and insert teachers from excel</option>
                                </b-select>
                                <button class='button is-info' v-on:click="uploadExcel()">
                                    Upload now
                                </button>
                            </b-field>
                            <p>*Overwrite duplicate is based on staff e-mail in this school.</p>         
                            <a class="button is-warning" v-on:click="downloadTemplate()">Download Excel (xlsx) template</a>                       
                        </div>
                    </div>
                </div>
                <br />

                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Add New Teacher</p>
                    </div>
                    <div class="card-content">
                        <div class="content"><data-create v-on:data-create="create"></data-create></div>
                    </div>
                </div>
                <br />

                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Teachers</p>
                    </div>
                    <div class="card-content">
                        <div class="content"><data-list v-bind:dataList="dataList"></data-list></div>
                    </div>
                </div>
                <br />

            </div>
        </div>
    </section>    
</div>
</template>

<script>
import SideMenu from '../SideMenu'
import axios from 'axios'
import DataList from '../Staff/DataList';
import DataCreate from '../Staff/DataCreate';
import { ToastProgrammatic as Toast } from 'buefy'

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'Main',
    components: {
        DataList,
        DataCreate,
        SideMenu,
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            input: {
                name: "",
                option1: null,
            },
            result: "",
            errors: [],
            dataList: [{
                firstName: '',
                lastName: '',
                staffEmail: '',
                done: false,
            }],
            file: null
        }
    },
    created() {
        this.getData()
    },
    beforeMount() {
        this.$emit("authenticated", true)
        console.log('before mount in TeachersMain')
        console.log("tokennn? " + localStorage.getItem('jwtToken'))
        console.log("sessionID? " + localStorage.getItem('sessionID'))
    },
    methods: {  
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        create(newData) {
            this.dataList.push(newData);
            Toast.open({
                color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                message: 'Teacher successfully added!',
                type: 'is-success',
                duration: 3000
            })
        },
        getData() {
            console.log("111 entering getData")
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/teachers/list', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID')
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    this.dataList = response.data
                    console.log(this.dataList)
                })
                .catch(e => {
                    this.errors.push(e)
                    console.log(e)
                })
        },
        uploadExcel(){
            console.log("Entering uploadExcel")
            console.log(this.input.option1)
            console.log(this.file)
            if (this.input.option1 != null && this.file != null){

                if (this.input.option1 == 2){
                    //remove all teachers and insert from the excel
                    this.$swal({
                        title: "Are you sure?",
                        text: "All teachers & its associated data will be removed first, then only the teachers inside the excel file will be processed. This will also make any current teachers QR tags no longer usable. To continue, enter 'CONFIRM REMOVE ALL TEACHERS' in the text field below and press OK",
                        input: 'text',
                        showCancelButton: true,
                        inputValidator: (value) => {
                            if (value == "CONFIRM REMOVE ALL TEACHERS"){
                                this.uploadExcelNow()
                            }else{
                                alert("You entered the wrong input. Excel is not processed.")
                                return false;
                            }
                        }
                    })
                }else{
                    this.uploadExcelNow()
                }
            }else{
                alert("Please select the excel file you want to upload and the overwrite option.")
                return false;
            }
        },
        uploadExcelNow(){

            this.isLoading = true;
            let formData = new FormData();                
            formData.append('email', localStorage.getItem('email'));
            formData.append('sessionID', localStorage.getItem('sessionID'));
            formData.append('file', this.file);
            formData.append('option1', this.input.option1);

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.post(process.env.MY_URL + '/api/teachers/import',
                formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(response => {
                console.log('SUCCESS!!');
                console.log(response)
                if (response.data.success == true) {
                    console.log("Teachers imported!")
                    this.file = null
                    this.input.option1 = null
                    this.getData();
                    this.isLoading = false
                    
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })

                } else {
                    this.errors.push(response.data.msg)
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    console.log(response.data.msg)
                    this.isLoading = false
                }
            })
            .catch(e => {
                console.log(e.response.data.msg)
                Toast.open({
                    message: e.response.data.msg,
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 5000
                })
                this.errors.push(e)
                this.isLoading = false
            });

        },
        downloadTemplate(){
            var downloadLink = "http://" + window.location.hostname + "/downloads/template_teachers.xlsx";
            window.open(downloadLink,"_blank")
        },
        downloadQRTags(){
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + '/api/teachers/qr_multiple', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID')
                    }
                })
                .then(response => {                    
                    console.log("217 reponse")
                    console.log(response)
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'tags.pdf'); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                    // let blob = new Blob([response.data], { type: 'application/pdf' }),
                    // url = window.URL.createObjectURL(blob)

                    //     window.open(url) 

                    // this.dataList = response.data
                    // console.log(this.dataList)
                })
                .catch(e => {
                    this.errors.push(e)
                    console.log(e)
                })
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Staff/Main.vue